const IconHeader = ({ icon, text }) => (
  <div className="ml-2 mb-6 border-b-4 border-theme inline-block">
    <span className="background-theme text-white inline-block text-2xl p-1 mt-2 mb-0  align-bottom rounded-t">
      {icon}
    </span>
    <h3 className="uppercase text-2xl font-semibold inline-block pl-3 pr-5 align-bottom">
      {text}
    </h3>
  </div>
);

export default IconHeader;
